import { Component, inject, Input, OnInit } from '@angular/core';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { DxPieChartComponent } from 'devextreme-angular';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { PercentPipe } from '@angular/common';
import {
  DxiSeriesComponent,
  DxoConnectorComponent,
  DxoExportComponent,
  DxoLabelComponent,
  DxoLegendComponent,
  DxoTooltipComponent,
} from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-chart-pie-tipologie',
  templateUrl: './chart-pie-tipologie.component.html',
  styleUrls: ['./chart-pie-tipologie.component.scss'],
  imports: [
    DxPieChartComponent,
    DxoLabelComponent,
    DxoConnectorComponent,
    DxiSeriesComponent,
    DxoExportComponent,
    DxoLegendComponent,
    DxoTooltipComponent,
  ],
  standalone: true,
})
export class ChartPieTipologieComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private movimentoArticoliService = inject(MovimentoArticoliService);

  @Input() idDipendente;
  pipe = new PercentPipe('it-IT');
  datiGrafici: any;

  ngOnInit() {
    this.loadDati();
  }

  /*customizeTooltip = ({ valueText, percent }: { valueText: string, percent: number }) => ({
    text: `${valueText} - ${this.pipe.transform(percent, '1.2-2')}`,
  });
*/
  customizeLabelText(arg: any) {
    return {
      text: `${arg.argumentText}: ${Math.round(arg.value)}`,
    };
  }

  loadDati() {
    this.movimentoArticoliService
      .datiGraficiTipologie(this.idDipendente)
      .subscribe({
        next: (res) => {
          if (res != null) {
            this.datiGrafici = res;
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero dati grafici');
        },
      });
  }
}
